// src/services/catalog.api.js
// Каталог категорій з Odoo

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8080";

function normalizeLang(lang) {
  return String(lang || "").toLowerCase().startsWith("en") ? "en" : "uk";
}

function withLang(path, lang = "uk") {
  const safeLang = normalizeLang(lang);
  const hasQuery = path.includes("?");
  return `${path}${hasQuery ? "&" : "?"}lang=${encodeURIComponent(safeLang)}`;
}

async function jget(path, lang = "uk") {
  const url = `${API_BASE}${withLang(path, lang)}`;

  const r = await fetch(url);
  const text = await r.text();

  let data = {};
  try {
    data = JSON.parse(text);
  } catch {}

  if (!r.ok || data?.ok === false) {
    throw new Error(data?.error || `HTTP ${r.status}`);
  }

  return data;
}

export async function apiCatalogMenu(lang = "uk") {
  const d = await jget("/api/catalog/menu", lang);

  // 🔥 тихий прогрів повного каталогу
  fetch(
    `${API_BASE}${withLang("/api/catalog/warmup", lang)}`
  ).catch(() => {});

  return d.categories || [];
}

export async function apiCatalogChildren(parentId, lang = "uk") {
  const q = parentId ? `?parent_id=${encodeURIComponent(parentId)}` : "";
  const d = await jget(`/api/catalog/children${q}`, lang);
  return d.categories || [];
}

export async function apiCatalogProducts(categoryId, lang = "uk") {
  const d = await jget(
    `/api/catalog/products?category_id=${encodeURIComponent(categoryId)}`,
    lang
  );

  console.log("[catalog] PRODUCTS RESPONSE SAMPLE =", d.products?.[0]);
  return d.products || [];
}

export async function apiCatalogReviews(productId, lang = "uk") {
  const d = await jget(
    `/api/catalog/reviews?product_id=${encodeURIComponent(productId)}&_=${Date.now()}`,
    lang
  );

  return d.items || [];
}